import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Lang } from '../../typings/common';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import * as keyset from './DirectLogo.i18n';

const i18n = i18nFactory(keyset);

interface DirectLogoProps {
    currentLang: Lang;
    cls?: string;
}

const DirectLogo = React.memo(({ currentLang, cls }: DirectLogoProps) => {
    const altText = i18n('direct');
    const shape = [Lang.en, Lang.tr].includes(currentLang) ? (
        <Shape2
            icon={Shape2Icon.directLogoEn}
            width={52}
            height={26}
            title={altText}
        />
    ) : (
        <Shape2
            icon={Shape2Icon.directLogoRu}
            width={70}
            height={28}
            title={altText}
        />
    );

    return shape;
});

export { DirectLogo };
